import React, {useMemo} from "react";
import {useSelector} from "react-redux";

import {compact} from "@pg-mono/nodash";
import {rpAppLink} from "@pg-mono/rp-routes";

import {Breadcrumbs} from "../../../app/components/breadcrumbs/Breadcrumbs";
import {IRPStore} from "../../../app/rp_reducer";
import {buildPromotionListUrl, buildPromotionListUrlFromRegion} from "../../helpers/build_promotion_list_url";
import {getPromotionListingConfig, getPromotionListingType} from "../../helpers/promotion_listing_config";
import {PromotionType} from "../../helpers/PromotionType";

export const PromotionListBreadcrumbs = () => {
    const promotionType = useSelector((state: IRPStore) => state.promotionList.form.formValues.type);
    const region = useSelector((state: IRPStore) => state.promotionList.region);

    const items = useMemo(() => {
        const listingType = getPromotionListingType(promotionType);
        const listingConfig = getPromotionListingConfig(listingType);

        return compact([
            {name: "Promocje", url: buildPromotionListUrl()},
            listingType !== PromotionType.PROMOTION && {
                name: listingConfig.fullLabel,
                url: buildPromotionListUrl({type: listingType})
            },
            !!region?.parent &&
                !!region?.parent?.slug && {
                    name: region.parent.name,
                    url: buildPromotionListUrlFromRegion({type: listingType, region: region.parent})
                },
            !!region && {
                name: region.name,
                url: buildPromotionListUrlFromRegion({type: listingType, region})
            }
        ]);
    }, [promotionType, region]);

    return <Breadcrumbs homePageUrl={rpAppLink.base()} items={items} />;
};
import React, {useMemo} from "react";
import {useSelector} from "react-redux";

import {compact} from "@pg-mono/nodash";
import {rpAppLink} from "@pg-mono/rp-routes";

import {Breadcrumbs} from "../../../app/components/breadcrumbs/Breadcrumbs";
import {IRPStore} from "../../../app/rp_reducer";
import {buildPromotionListUrl, buildPromotionListUrlFromRegion} from "../../helpers/build_promotion_list_url";
import {getPromotionListingConfig, getPromotionListingType} from "../../helpers/promotion_listing_config";
import {PromotionType} from "../../helpers/PromotionType";

export const PromotionListBreadcrumbs = () => {
    const promotionType = useSelector((state: IRPStore) => state.promotionList.form.formValues.type);
    const region = useSelector((state: IRPStore) => state.promotionList.region);

    const items = useMemo(() => {
        const listingType = getPromotionListingType(promotionType);
        const listingConfig = getPromotionListingConfig(listingType);

        return compact([
            {name: "Promocje", url: buildPromotionListUrl()},
            listingType !== PromotionType.PROMOTION && {
                name: listingConfig.fullLabel,
                url: buildPromotionListUrl({type: listingType})
            },
            !!region?.parent &&
                !!region?.parent?.slug && {
                    name: region.parent.name,
                    url: buildPromotionListUrlFromRegion({type: listingType, region: region.parent})
                },
            !!region && {
                name: region.name,
                url: buildPromotionListUrlFromRegion({type: listingType, region})
            }
        ]);
    }, [promotionType, region]);

    return <Breadcrumbs homePageUrl={rpAppLink.base()} items={items} />;
};
